import styles from './rights-wrapper.module.scss';
import React from 'react';
import { GetRoles } from '../TokenContext';
import { checkUserAccess, Roles } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface RightsWrapperProps {
  requiredAccess?: Roles,
  children: any
}

export function RightsWrapper(props: RightsWrapperProps) {
  const userRole = GetRoles();
  const { hasAccess, noAccessMessage } = checkUserAccess(userRole, props.requiredAccess);

  const modifyChildren = (child: any) => {
    const className = child.props.className + ` ${!hasAccess && styles["disabled"]}`;
    const props = { className };
    return React.cloneElement(child, props);
  };

  const clonedChildren = React.Children.map(props.children, (child: any) => modifyChildren(child));

  return <span title={!hasAccess ? noAccessMessage : ""}>
    {clonedChildren}
  </span>

};

export default RightsWrapper;